<template>
  <div id="app">
    <NavBar @showAside="show" :key="Math.random()"/>
    <MobileAside :key="Math.random()" :class="{slide: mobileNavOpen, 'slide-reverse': !mobileNavOpen }" @hideAside="hide"/>
    <router-view />
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import MobileAside from '@/components/MobileAside.vue'

export default{
  components:{
    NavBar,
    Footer,
    MobileAside
  },
  mounted(){
    this.mobileNavOpen = false
  },
  data(){
    return{
      mobileNavOpen: false
    }
  },
  methods:{
    hide(){
      this.mobileNavOpen = false
    },
    show(){
      this.mobileNavOpen = true
    }
  }
}
</script>
<style>
.slide{
  transform: translate(0,0);

  animation: slide -.1s linear forwards;
}
.slide-reverse{
  transform: translate(-100%,0);

  animation: slide-reverse -.1s linear forwards;
}
@keyframes slide{
  100%{
    transform: translate(0,0);
  }
}
@keyframes slide-reverse{
  100%{
    transform: translate(-100%,0);
  }
}
</style>
